/*
 * PERF 22-09 (A2-fix) — my-barbecue.com
 *
 * Porque existe este ficheiro:
 * As miniaturas da galeria de produto vivem numa tira com scroll horizontal
 * (.product__thumbs__holder, overflow-x: auto). Verificado em producao a 22/09/2026:
 * o carregamento lazy NATIVO nunca dispara dentro dessa tira — miniaturas visiveis
 * dentro da tira ficam por carregar indefinidamente, e nem fazer scroll a tira as
 * traz. Forcar img.loading = 'eager' carrega-as no instante seguinte.
 *
 * Este script faz exactamente isso: quando a tira se aproxima do ecra (ou quando o
 * visitante lhe toca), passa as miniaturas que ficaram em lazy para eager.
 * O proprio tema ja usa esta tecnica no product-thumbs.js (preloadImagesOnHover).
 *
 * Reverter: apagar este ficheiro e a linha que o carrega em sections/product.liquid.
 */
(function () {
  'use strict';

  function upgrade(scope) {
    var imgs = scope.querySelectorAll('[data-thumb-item] img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].loading = 'eager';
    }
  }

  function setup(el) {
    if (el.dataset.perfThumbsReady) return;
    el.dataset.perfThumbsReady = '1';

    var holder = el.querySelector('[data-thumbs-slider]') || el;
    var done = false;

    function run() {
      if (done) return;
      done = true;
      upgrade(el);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              run();
              io.disconnect();
              return;
            }
          }
        },
        { rootMargin: '200px' }
      );
      io.observe(el);
    } else {
      run();
    }

    // Rede de seguranca: qualquer toque na tira carrega tudo de imediato.
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin', 'scroll'].forEach(function (ev) {
      holder.addEventListener(ev, run, { once: true, passive: true });
    });
  }

  function init(root) {
    var list = (root || document).querySelectorAll('product-thumbs');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Editor do tema: seccoes recarregadas ao vivo.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
